import Vue from 'vue';

import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);

import App from './App.vue';
import router from './router';
import store from './store';
require('./store/modules');

import { ReactiveRefs } from 'vue-reactive-refs';
import vuetify from './plugins/vuetify';
Vue.use(ReactiveRefs);

import { VuePlugin } from 'vuera';
Vue.use(VuePlugin);

import { Chart, registerables } from 'chart.js';
Chart.register(...registerables);
import ChartDataLabels from 'chartjs-plugin-datalabels';
Chart.register(ChartDataLabels);

import ElementQueries from 'css-element-queries';
ElementQueries.ElementQueries.listen();

Vue.config.productionTip = false;

new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
}).$mount('#app');
